import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p1" }
const _hoisted_2 = { class: "p1" }
const _hoisted_3 = { class: "p1" }
const _hoisted_4 = { class: "p1" }

import type { AdminUserCsvResult } from 'src/models/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserCsvUploadModal',
  props: {
    showConfirm: { type: Boolean },
    showComplete: { type: Boolean },
    showError: { type: Boolean },
    uploadingCsv: {},
    csvResult: {},
    csvErrorBody: {},
    isUploading: { type: Boolean }
  },
  emits: ["confirm", "dismissConfirm", "dismissComplete", "dismissError"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showConfirm)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: "確認",
          isCloseButtonBusy: __props.isUploading,
          showBottomDismissButton: !__props.isUploading,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm'))),
          onDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dismissConfirm')))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "p1" }, "CSVアップロードによるユーザーの一括更新を行います。", -1)),
              _createElementVNode("p", _hoisted_1, "選択ファイル: " + _toDisplayString(__props.uploadingCsv?.name), 1),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "p2" }, "よろしいですか？", -1))
            ])
          ]),
          _: 1
        }, 8, ["isCloseButtonBusy", "showBottomDismissButton"]))
      : _createCommentVNode("", true),
    (__props.showComplete)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          title: "CSVアップロード結果",
          showBottomDismissButton: false,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('dismissComplete')))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              (__props.csvResult?.hasErrors)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "p1" }, "CSVアップロードに失敗しました。", -1)),
                    _createElementVNode("p", _hoisted_2, "失敗件数: " + _toDisplayString(__props.csvResult.failures.length) + "件", 1),
                    _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.csvResult.failures, (failure, fi) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "text-danger ml8",
                        key: fi
                      }, [
                        _createTextVNode(_toDisplayString(failure.row.dataNum) + "行目: ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(failure.reasons, (reason, ri) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "ml8",
                            key: ri
                          }, _toDisplayString(reason), 1))
                        }), 128))
                      ]))
                    }), 128))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "p1" }, "CSVアップロードに成功しました。", -1)),
                    _createElementVNode("p", _hoisted_3, "新規件数: " + _toDisplayString(__props.csvResult?.created.length) + "件", 1),
                    _createElementVNode("p", _hoisted_4, "更新件数: " + _toDisplayString(__props.csvResult?.updated.length) + "件", 1)
                  ], 64))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.showError)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          title: "CSVエラー",
          body: __props.csvErrorBody,
          showBottomDismissButton: false,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('dismissError')))
        }, null, 8, ["body"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})